<template>
    <div class="custom-marker-icon rounded-circle" :style="style">
      <div class="gm-dot" :style="style">
        <img
          v-if="!!icon"
          class="sub-icon"
          :src="icon" />
        <div
          v-else-if="iconName"
          :class="`bi-${iconName} marker-text`"
        />
        <div v-else-if="count" class="marker-text">
          {{ count }}
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    color: String,
    icon: String,
    iconName: String,
    count: Number
  },
  computed: {
    borderColor() {
      return 'ffffff';
    },
    bgColor() {
      return this.color;
    },
    scale() {
      return 2;
    },
    style() {
      let color = this.color;
      if (color.match(/^[0-9a-f]{3}$/i) || color.match(/^[0-9a-f]{6}$/i)) {
        color = `#${color}`;
      }
      return {
        'background-color': color
      };
    }
  }
}
</script>

<style>
.custom-marker-icon {
  opacity: 1;
  width: 0px;
  height: 0px;
}
/*.custom-marker-icon.selected {*/
/*  opacity: 1;*/
/*  width: 0px;*/
/*  height: 0px;*/
/*}*/
.custom-marker-icon img.marker-icon {
  width: 20px;
  position: absolute;
  bottom: 50%;
  right: 50%;
  margin-right: -10px;
  /*transition: width 250ms, margin 250ms;*/
}
/*.custom-marker-icon.selected img.marker-icon {*/
/*  width: 32px;*/
/*  margin-right: -16px;*/
/*}*/
.custom-marker-icon img.sub-icon {
  width: 7px;
  height: 7px;
  object-fit: contain;
  position: absolute;
  margin-bottom: 3px;
  margin-left: 3px;
  bottom: 0;
  filter: brightness(100);
  opacity: 0;
  transition: opacity 250ms;
  /*transition: margin 250ms, width 250ms, height 250ms;*/
}
.custom-marker.highlighted>.custom-marker-icon img.sub-icon {
  opacity: 1;
}
/*.custom-marker-icon.selected img.sub-icon {*/
/*  width: 16px;*/
/*  height: 16px;*/
/*  margin-bottom: 19px;*/
/*  margin-left: -8px;*/
/*}*/
.custom-marker-icon .marker-text {
  color: #fff;
  font-weight: 700;
  position: absolute;
  text-align: center;
  width: 48px;
  margin-left: -24px;
  left: 50%;
  top: 50%;
  margin-top: -27px;
}
.gm-dot {
  width: 16px;
  height: 16px;
  border-radius: 9999px;          /* perfect circle */
  background: #888888;            /* will be overridden by inline style */
  border: 1.5px solid white;        /* halo for contrast on any map tile */
  box-shadow: 0 0 0 2px rgba(0,0,0,.15);
  /* anchor the dot’s center to the geographic point */
  transform: translate(-50%, -50%);
  /* optional: pointer + hover affordance */
  cursor: pointer;
}
.gm-dot:hover {
  box-shadow: 0 0 0 3px rgba(0, 0, 0, .2);
}
</style>
